module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "organisations-modal text-dark",
    class: {
      'organisations-modal--full': _vm.isFullSize
    },
    attrs: {
      "slot": "insertComponent"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "organisations-modal__header"
  }, [_c('h2', [_vm._v("Organisationer")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle organisations-modal__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "organisations-modal__tabs"
  }, [_c('Tabs', {
    attrs: {
      "tabs": _vm.theTabs,
      "selected": _vm.activeTab,
      "isLarge": true
    },
    on: {
      "select": _vm.setActiveTab
    }
  })], 1), _vm._v(" "), (_vm.activeTab === 'select') ? [_c('div', {
    staticClass: "organisations-modal__content"
  }, [_c('p', {
    staticClass: "organisations-modal__explainer"
  }, [_vm._v("\n          Vælg de organisationer, der skal hentes ansættelser ud fra.\n        ")]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bgColor": "#fff"
    }
  }) : [(_vm.organisations.length === 0) ? _c('p', {
    staticClass: "italic"
  }, [_vm._v("\n            Der blev ikke fundet nogen organisationer.\n          ")]) : _c('ul', {
    staticClass: "organisations-modal__list"
  }, _vm._l((_vm.organisations), function(organisation) {
    return _c('li', {
      key: organisation,
      staticClass: "organisations-modal__list__item",
      class: {
        'organisations-modal__list__item--active': _vm.isSelected(organisation)
      },
      on: {
        "click": function($event) {
          return _vm.toggleOrganisation(organisation)
        }
      }
    }, [_c('div', {
      staticClass: "organisations-modal__list__item__name"
    }, [_c('span', {
      staticClass: "icon-home2"
    }), _vm._v(" "), _c('div', [_vm._v("\n                  " + _vm._s(organisation) + "\n                  "), _c('div', {
      staticClass: "organisations-modal__list__item__counts"
    }, [_vm._v("\n                    " + _vm._s(_vm.organisationCounts(organisation).total) + "\n                    " + _vm._s(_vm.organisationCounts(organisation).total === 1 ? 'ansættelse' : 'ansættelser') + ",\n                    heraf " + _vm._s(_vm.organisationCounts(organisation).withTemplate) + " med stillingskategori\n                  ")])])]), _vm._v(" "), (_vm.isSelected(organisation)) ? _c('div', {
      staticClass: "icon__checkmark"
    }, [_c('span', {
      staticClass: "icon-checkmark-circle"
    })]) : _vm._e()])
  }), 0)]], 2), _vm._v(" "), _c('div', {
    staticClass: "organisations-modal__buttons"
  }, [_c('span', {
    staticClass: "organisations-modal__count"
  }, [_vm._v("\n          Valgt " + _vm._s(_vm.selectedOrganisations.length) + " af " + _vm._s(_vm.organisations.length) + "\n        ")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': _vm.isLoading || _vm.isSaving,
      'do-bttn--submit--loading': _vm.isSaving
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n            Gem\n          ")])])])] : _vm._e(), _vm._v(" "), (_vm.activeTab === 'outside') ? [_c('div', {
    staticClass: "organisations-modal__content organisations-modal__content--full"
  }, [_c('p', {
    staticClass: "organisations-modal__explainer"
  }, [_vm._v("\n          Løn- og fraværsoverførsler på ansættelser, hvis organisation ikke er blandt de valgte.\n          Brug listen til at finde overførsler, der ved en fejl er lavet på en forkert organisation.\n        ")]), _vm._v(" "), (_vm.outsideData && _vm.outsideData.salary_organisations.length === 0) ? _c('p', {
    staticClass: "organisations-modal__warning"
  }, [_vm._v("\n          Der er ikke valgt nogen organisationer endnu, så alle ansættelser vises.\n          Vælg organisationer under \"1. Vælg organisationer\".\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isLoadingOutside) ? _c('Loader', {
    attrs: {
      "bgColor": "#fff"
    }
  }) : (_vm.outsideData) ? [_c('div', {
    staticClass: "organisations-modal__outside-summary"
  }, [_c('span', [_vm._v("\n              " + _vm._s(_vm.outsideEmployments.length) + "\n              " + _vm._s(_vm.outsideEmployments.length === 1 ? 'ansættelse' : 'ansættelser') + "\n              uden for de valgte organisationer, heraf\n              " + _vm._s(_vm.employmentsWithTransfers.length) + " med overførsler\n            ")]), _vm._v(" "), (_vm.outsideEmployments.length > _vm.employmentsWithTransfers.length) ? _c('label', {
    staticClass: "organisations-modal__outside-toggle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isShowAllOutside),
      expression: "isShowAllOutside"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isShowAllOutside) ? _vm._i(_vm.isShowAllOutside, null) > -1 : (_vm.isShowAllOutside)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isShowAllOutside,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isShowAllOutside = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isShowAllOutside = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isShowAllOutside = $$c
        }
      }
    }
  }), _vm._v("\n              Vis også ansættelser uden overførsler\n            ")]) : _vm._e()]), _vm._v(" "), (_vm.shownEmployments.length === 0) ? _c('p', {
    staticClass: "italic"
  }, [_vm._v("\n            Ingen overførsler fundet uden for de valgte organisationer.\n          ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.shownEmployments), function(employment) {
    return _c('div', {
      key: employment.employment_id,
      staticClass: "outside-employment"
    }, [_c('div', {
      staticClass: "outside-employment__header"
    }, [_c('div', {
      staticClass: "outside-employment__header__who"
    }, [_c('strong', [_vm._v(_vm._s(employment.user_name))]), _vm._v(" "), _c('span', {
      staticClass: "outside-employment__header__number"
    }, [_vm._v("\n                  " + _vm._s(employment.employment_number)), (employment.source_title) ? [_vm._v(" - " + _vm._s(employment.source_title))] : _vm._e()], 2), _vm._v(" "), _vm._l((employment.positions), function(position) {
      return (position.title) ? _c('div', {
        key: position.school_employment_id,
        staticClass: "d-tag"
      }, [_vm._v("\n                  " + _vm._s(position.title) + "\n                ")]) : _vm._e()
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "do-pill do-pill--small do-pill--yellow"
    }, [_vm._v("\n                " + _vm._s(employment.organisation || 'Ingen organisation') + "\n              ")])]), _vm._v(" "), (employment.v_salary_days.length > 0) ? _c('div', {
      staticClass: "outside-employment__section"
    }, [_c('h4', [_vm._v("Vikarløn - dage")]), _vm._v(" "), _c('table', {
      staticClass: "outside-table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', [_vm._v("Tid på ansættelsen")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Godkendt")])])]), _vm._v(" "), _c('tbody', _vm._l((employment.v_salary_days), function(day) {
      return _c('tr', {
        key: 'day-' + day.id
      }, [_c('td', [_vm._v(_vm._s(_vm.formatDate(day.day)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(day.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatMinutes(day.v_minutes)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(day.state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(day.approved_at)))])])
    }), 0)])]) : _vm._e(), _vm._v(" "), (employment.v_kmd_rows.length > 0) ? _c('div', {
      staticClass: "outside-employment__section"
    }, [_c('h4', [_vm._v("Engangsydelser - OPUS")]), _vm._v(" "), _c('table', {
      staticClass: "outside-table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Lønart")]), _vm._v(" "), _c('th', [_vm._v("Antal")]), _vm._v(" "), _c('th', [_vm._v("Beløb")]), _vm._v(" "), _c('th', [_vm._v("Omk.sted")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Sendt")])])]), _vm._v(" "), _c('tbody', _vm._l((employment.v_kmd_rows), function(row, idx) {
      return _c('tr', {
        key: 'kmd-' + idx
      }, [_c('td', [_vm._v(_vm._s(_vm.formatDate(row.Startdato)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.Loenart))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.Antal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.Beloeb))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.Afv_Omkostningssted || '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.v_status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(row.v_created_at)))])])
    }), 0)])]) : _vm._e(), _vm._v(" "), (employment.sd_engangsydelser.length > 0) ? _c('div', {
      staticClass: "outside-employment__section"
    }, [_c('h4', [_vm._v("Engangsydelser - SD")]), _vm._v(" "), _c('table', {
      staticClass: "outside-table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Lønart")]), _vm._v(" "), _c('th', [_vm._v("Enheder")]), _vm._v(" "), _c('th', [_vm._v("Sats")]), _vm._v(" "), _c('th', [_vm._v("Dage")]), _vm._v(" "), _c('th', [_vm._v("Timer")]), _vm._v(" "), _c('th', [_vm._v("Beskrivelse")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Godkendt")])])]), _vm._v(" "), _c('tbody', _vm._l((employment.sd_engangsydelser), function(ydelse) {
      return _c('tr', {
        key: 'sdy-' + ydelse.id
      }, [_c('td', [_vm._v(_vm._s(_vm.formatSdDate(ydelse)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ydelse.loenart))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ydelse.enheder))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ydelse.sats))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ydelse.dage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ydelse.timer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ydelse.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ydelse.state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(ydelse.approved_at)))])])
    }), 0)])]) : _vm._e(), _vm._v(" "), (employment.sd_fravaer.length > 0) ? _c('div', {
      staticClass: "outside-employment__section"
    }, [_c('h4', [_vm._v("Fravær - SD")]), _vm._v(" "), _c('table', {
      staticClass: "outside-table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Periode")]), _vm._v(" "), _c('th', [_vm._v("Lønart")]), _vm._v(" "), _c('th', [_vm._v("Dage")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Godkendt")])])]), _vm._v(" "), _c('tbody', _vm._l((employment.sd_fravaer), function(fravaer) {
      return _c('tr', {
        key: 'sdf-' + fravaer.id
      }, [_c('td', [_vm._v(_vm._s(_vm.formatPeriod(fravaer.startdato, fravaer.slutdato)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fravaer.loenart))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fravaer.dagdecimal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(fravaer.state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(fravaer.approved_at)))])])
    }), 0)])]) : _vm._e(), _vm._v(" "), (employment.sd_loenaendringer.length > 0) ? _c('div', {
      staticClass: "outside-employment__section"
    }, [_c('h4', [_vm._v("Lønændringer - SD")]), _vm._v(" "), _c('table', {
      staticClass: "outside-table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Deltidskode")]), _vm._v(" "), _c('th', [_vm._v("Løndecimal")]), _vm._v(" "), _c('th', [_vm._v("Beskæftigelsesdecimal")]), _vm._v(" "), _c('th', [_vm._v("Årstimetal")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Godkendt")])])]), _vm._v(" "), _c('tbody', _vm._l((employment.sd_loenaendringer), function(aendring) {
      return _c('tr', {
        key: 'sdl-' + aendring.id
      }, [_c('td', [_vm._v(_vm._s(_vm.formatDate(aendring.dato)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(aendring.deltidskode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(aendring.loendecimal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(aendring.beskaeftigelsesdecimal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(aendring.aarstimetal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(aendring.state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(aendring.approved_at)))])])
    }), 0)])]) : _vm._e(), _vm._v(" "), (employment.sd_tillaeg.length > 0) ? _c('div', {
      staticClass: "outside-employment__section"
    }, [_c('h4', [_vm._v("Tillæg - SD")]), _vm._v(" "), _c('table', {
      staticClass: "outside-table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Ændringskode")]), _vm._v(" "), _c('th', [_vm._v("Tillægsnummer")]), _vm._v(" "), _c('th', [_vm._v("Enheder")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Godkendt")])])]), _vm._v(" "), _c('tbody', _vm._l((employment.sd_tillaeg), function(tillaeg) {
      return _c('tr', {
        key: 'sdt-' + tillaeg.id
      }, [_c('td', [_vm._v(_vm._s(_vm.formatDate(tillaeg.dato)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tillaeg.aendringskode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tillaeg.tillaegsnummer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tillaeg.enheder))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tillaeg.state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(tillaeg.approved_at)))])])
    }), 0)])]) : _vm._e(), _vm._v(" "), (employment.salary_supplements.length > 0) ? _c('div', {
      staticClass: "outside-employment__section"
    }, [_c('h4', [_vm._v("Ydelser og tillæg")]), _vm._v(" "), _c('table', {
      staticClass: "outside-table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Lønkode")]), _vm._v(" "), _c('th', [_vm._v("Skoleår")]), _vm._v(" "), _c('th', [_vm._v("Enheder")]), _vm._v(" "), _c('th', [_vm._v("Rater")]), _vm._v(" "), _c('th', [_vm._v("Periode")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Godkendt")])])]), _vm._v(" "), _c('tbody', _vm._l((employment.salary_supplements), function(supplement) {
      return _c('tr', {
        key: 'sup-' + supplement.id
      }, [_c('td', [_vm._v(_vm._s(supplement.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.school_year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.units))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.installments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatPeriod(supplement.valid_from, supplement.valid_to)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(supplement.state))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(supplement.approved_at)))])])
    }), 0)])]) : _vm._e(), _vm._v(" "), (employment.absences.length > 0) ? _c('div', {
      staticClass: "outside-employment__section"
    }, [_c('h4', [_vm._v("Fravær")]), _vm._v(" "), _c('table', {
      staticClass: "outside-table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Årsag")]), _vm._v(" "), _c('th', [_vm._v("Periode")]), _vm._v(" "), _c('th', [_vm._v("Tid")]), _vm._v(" "), _c('th', [_vm._v("Fraværskode")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', _vm._l((employment.absences), function(absence) {
      return _c('tr', {
        key: 'abs-' + absence.event_serial_id
      }, [_c('td', [_vm._v(_vm._s(absence.subject_name))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.formatDate(absence.from_date)) + "\n                    "), (absence.ongoing) ? [_vm._v("- løbende")] : (absence.to_date && absence.to_date !== absence.from_date) ? [_vm._v("- " + _vm._s(_vm.formatDate(absence.to_date)))] : _vm._e()], 2), _vm._v(" "), _c('td', [(absence.use_time) ? [_vm._v(_vm._s(absence.from_time) + " - " + _vm._s(absence.to_time))] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(absence.kmd_absence_code || absence.sd_absence_code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(absence.state))])])
    }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.transfersCount(employment) === 0) ? _c('p', {
      staticClass: "italic organisations-modal__no-transfers"
    }, [_vm._v("\n              Ingen overførsler på denne ansættelse.\n            ")]) : _vm._e()])
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "organisations-modal__buttons"
  }, [_c('span'), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n            Luk\n          ")])])])] : _vm._e(), _vm._v(" "), (_vm.activeTab === 'unused') ? [_c('div', {
    staticClass: "organisations-modal__content organisations-modal__content--full"
  }, [_c('p', {
    staticClass: "organisations-modal__explainer"
  }, [_vm._v("\n          Ansættelser uden for de valgte organisationer, som intet er bogført på -\n          hverken vikarløn, ydelser eller fravær. De kan slettes, uden at skolen mister noget.\n        ")]), _vm._v(" "), (_vm.isUnusedLoaded && _vm.school && Array.isArray(_vm.school.salary_organisations) && _vm.school.salary_organisations.length === 0) ? _c('p', {
    staticClass: "organisations-modal__warning"
  }, [_vm._v("\n          Der er ikke valgt nogen organisationer endnu, så alle ubrugte ansættelser vises.\n          Vælg organisationer under \"1. Vælg organisationer\".\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isLoadingUnused) ? _c('Loader', {
    attrs: {
      "bgColor": "#fff"
    }
  }) : (_vm.isUnusedLoaded) ? [(_vm.unusedEmployments.length === 0) ? _c('p', {
    staticClass: "italic"
  }, [_vm._v("\n            Ingen ubrugte ansættelser uden for de valgte organisationer.\n          ")]) : _c('table', {
    staticClass: "outside-table outside-table--boxed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Medarbejder")]), _vm._v(" "), _c('th', [_vm._v("Ansættelse")]), _vm._v(" "), _c('th', [_vm._v("Titel")]), _vm._v(" "), _c('th', [_vm._v("Organisation")]), _vm._v(" "), _c('th', [_vm._v("Periode")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.unusedEmployments), function(position) {
    return _c('tr', {
      key: 'unused-' + position.id
    }, [_c('td', [_vm._v(_vm._s(_vm.userName(position.user_id)))]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(position.employment_number)), (position.source_title) ? [_vm._v(" - " + _vm._s(position.source_title))] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(position.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(position.organisation || 'Ingen organisation'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatPeriod(position.start_date, position.end_date)))])])
  }), 0)])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "organisations-modal__buttons"
  }, [(_vm.isConfirmingUnusedDelete) ? _c('span', {
    staticClass: "organisations-modal__count"
  }, [_vm._v("\n          Er du sikker? " + _vm._s(_vm.unusedEmployments.length) + "\n          " + _vm._s(_vm.unusedEmployments.length === 1 ? 'ansættelse markeres' : 'ansættelser markeres') + " som slettet.\n        ")]) : _c('span'), _vm._v(" "), _c('div', [(_vm.isConfirmingUnusedDelete) ? [_c('button', {
    staticClass: "do-bttn",
    attrs: {
      "disabled": _vm.isDeletingUnused
    },
    on: {
      "click": function($event) {
        _vm.isConfirmingUnusedDelete = false
      }
    }
  }, [_vm._v("\n              Fortryd\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': _vm.isDeletingUnused,
      'do-bttn--submit--loading': _vm.isDeletingUnused
    },
    on: {
      "click": _vm.deleteUnused
    }
  }, [_vm._v("\n              Ja, slet " + _vm._s(_vm.unusedEmployments.length) + "\n              " + _vm._s(_vm.unusedEmployments.length === 1 ? 'ansættelse' : 'ansættelser') + "\n            ")])] : [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n              Luk\n            ")]), _vm._v(" "), (_vm.unusedEmployments.length > 0) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': _vm.isLoadingUnused
    },
    on: {
      "click": function($event) {
        _vm.isConfirmingUnusedDelete = true
      }
    }
  }, [_vm._v("\n              Slet " + _vm._s(_vm.unusedEmployments.length) + " ubrugte\n              " + _vm._s(_vm.unusedEmployments.length === 1 ? 'ansættelse' : 'ansættelser') + "\n            ")]) : _vm._e()]], 2)])] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16c7a552!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettings/SalaryOrganisationsModal.vue
// module id = 1776
// module chunks = 1